import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/stock-alert-setting',
    name: 'stock-alert-setting',
    meta: { middleware: authenticate },
    component: () => import('@/pages/inventory/stock-alert-setting/index.vue')
  }
]
